export default __webpack_public_path__ + "static/monthly-subscription-1ebaee8c80718a8034cc2e8b86218e4c.png";